export enum FilterType {
  Single = 'SINGLE',
  MultiImage = 'MULTI_IMAGE',
  MultiFlow = 'MULTI_FLOW',
  SingleTree = 'SINGLE_TREE',
  Slide = 'SLIDE',
}
